export default {
  createTopicFeedbackAction: '/topicFeedbackAction/createTopicFeedbackAction',
  getTopicFeedbackActionsOfATopicFeedback: '/topicFeedbackAction/getTopicFeedbackActionsOfATopicFeedback',
  submitActionByAStudentForATopicFeedbackAction: '/topicFeedbackAction/submitActionByAStudentForATopicFeedbackAction',
  submitActionResponseByAFacultyForATopicFeedbackAction: '/topicFeedbackAction/submitActionResponseByAFacultyForATopicFeedbackAction'
}
